import { User } from '../../types/user';
import { RootState } from '../rootReducer';

export const getUserState = (state: RootState): User => state.user;
